import template from './filterWidget.jade';
import ObservablesModule from '../../services/observables';
import EventEmitter from '../../services/eventEmitter';
import LocalizationModule from '../../configs/localization/localization';
import FiltersModule from '../../filters/filters';

export class FilterWidgetController {
  /* @ngInject */
  constructor(currentGame, $filter) {
    this.sortSelectedOnTop = $filter('sortSelectedOnTop');
    this.events = this.events || new EventEmitter();
    this.translateCountry = $filter('translateCountry');
    this.currentGame = currentGame;
    this.chooseTypeOfConfig();
  };

  chooseTypeOfConfig() {
    const vm = this;
    this.currentGame.subscribe(game => {
      vm.game = game;
      vm.updateFields(game);
    });
  }

  updateFields(game) {
    if(this.customFieldConfigs){
      this.setCustomFieldConfigs(game);
    } else {
      this.setFieldConfigs(game);
    }
  }
  processConfigs() {
    return _.forEach(this.field_configs, (field, key) => {
      if (field.field_type === 'bool') {
        field.possible_values = ['true', 'false'];
      }
      return field;
    });
  }

  setCustomFieldConfigs(game) {
    this.searchText = '';
    this.selectedDimension = {};

    if(game.simplaex_field_configs) {
      if(this.customFieldConfigs.countryCode) {
        this.customFieldConfigs.countryCode = game.simplaex_field_configs.countryCode;
      }
      if(this.customFieldConfigs.platform) {
        this.customFieldConfigs.platform = game.simplaex_field_configs.platform;
      }
      if(this.customFieldConfigs.paying) {
        this.customFieldConfigs.paying = game.simplaex_field_configs.paying;
      }
      if(this.customFieldConfigs.acquisitionSource) {
        this.customFieldConfigs.acquisitionSource = game.simplaex_field_configs.acquisitionSource;
      }
    }

    this.field_configs = this.customFieldConfigs;
    this.field_configs = this.processConfigs();
    this.setSelectedParams();
  }

  setFieldConfigs(game) {
    this.game = game;
    this.searchText = '';
    this.selectedDimension = {};
    this.field_configs = _.pick(
      this.game.simplaex_field_configs,
      [
        'countryCode',
        'platform',
        'paying',
        'acquisitionSource'
      ]);

    this.field_configs = this.processConfigs();
    this.setSelectedParams();
  }

  selectDimension(dimension) {
    this.selectedDimension = dimension;
    this.searchText = '';
  };

  setSelectedParams() {
    let fieldKey = '';
    this.field_configs = _.forEach(this.field_configs, (field, key) => {
      fieldKey = key;
      field.possible_values_descriptors = this.sortSelectedOnTop(_.map(field.possible_values, value => {
        if(typeof value === 'object') {
          return {
            valueToShow: value.valueToShow,
            value: value.value,
            selected: this.searchParams[fieldKey] && this.searchParams[fieldKey].split(',').indexOf(value.value) > -1
          }
        } else {
          return {
            valueToShow: this.translateCountry(value, fieldKey),
            value: value,
            selected: this.searchParams[fieldKey] && this.searchParams[fieldKey].split(',').indexOf(value) > -1
          }
        }
      }));
      return field;
    });
  }

  buildSearchParams() {
    let searchParams = {};

    _.forEach(this.field_configs, (fieldConfig, key) => {
      let noValuesAdded = true;
      _.forEach(fieldConfig.possible_values_descriptors, (value) => {
        if(value.selected) {
          if(noValuesAdded) {
            searchParams[key] = '';
          } else {
            searchParams[key] += ',';
          }
          searchParams[key] += value.value;
          noValuesAdded = false;
        }
      });
      if(noValuesAdded) {
        delete searchParams[key];
      }

    });

    this.searchParams = searchParams;
  }
};

export function FilterWidgetComponent() {
  return {
    template,
    controller: FilterWidgetController,
    restrict: 'E',
    replace: true,
    bindToController: true,
    controllerAs: 'vm',
    scope: {
      searchParams: '=',
      customFieldConfigs: '=',
      isOpen: '='
    },
    link: function(scope, element, attrs) {
      let openClass = 'is-open';

      scope.$on('$destroy', function() {
      });

      scope.$on('openFilterWidget', () => {
        scope.vm.updateFields(scope.vm.game);
        scope.vm.isOpen = true;
        if(scope.vm.field_configs) {
          scope.vm.selectDimension(scope.vm.field_configs[Object.keys(scope.vm.field_configs)[0]]);
        }
        scope.vm.setSelectedParams();
        element.addClass(openClass);
      });

      scope.vm.close = () => {
        scope.vm.isOpen = false;
        element.removeClass(openClass);
      };

      scope.vm.applyFilters = () => {
        scope.vm.buildSearchParams();
        element.removeClass(openClass);
      };
    }
  };
}

export default angular.module('app.common.filterwidget', [
  ObservablesModule.name,
  LocalizationModule.name,
  FiltersModule.name
])
  .directive('filterWidget', FilterWidgetComponent);



/** WEBPACK FOOTER **
 ** ./src/common/filter/filterWidget.js
 **/